import DXFWriter from '@tarikjabiri/dxf';

import { Vertex2 } from '@rta/rta-blueprint-library';

import { Layer, type Vector } from '@r-core/types';

export const drawVectors = (vectors: Array<Vector<Vertex2>>, drawing: DXFWriter): void => {
	for (let index = 0; index < vectors.length; index++) {
		const vector = vectors[index];
		const { from, to } = vector;

		drawing.setCurrentLayer(vector.layer);
		drawing.addLine(from.x, -from.y, to.x, -to.y);

		// Add Finished Edge Markers
		if (vector.metadata.finishedEdge) {
			const xCenter = from.x + ((to.x - from.x) / 2);
			const yCenter = -from.y + ((-to.y - -from.y) / 2);
			// drawing.addCircle(from.x, -from.y, 0.2);
			drawing.setCurrentLayer(Layer.FinishedEdge);
			drawing.addCircle(xCenter, yCenter, 0.4);
			drawing.addText(xCenter - 0.3, yCenter - 0.3, 0.8, 'X');
		}
	}
};
